var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalPosterInox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 187,
    viewBox: "0 0 327 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32327_1325)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 187,
    fill: "#12264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.391 161.875L293.406 157.484L290 154.531L294.5 154.141L296.25 150L298 154.141L302.5 154.531L299.094 157.484L300.109 161.875L296.25 159.547L292.391 161.875Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.391 96.875L323.406 92.484L320 89.531L324.5 89.141L326.25 85L328 89.141L332.5 89.531L329.094 92.484L330.109 96.875L326.25 94.547L322.391 96.875Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.594 31.9167L296.271 28.9896L294 27.0208L297 26.7604L298.167 24L299.333 26.7604L302.333 27.0208L300.063 28.9896L300.74 31.9167L298.167 30.3646L295.594 31.9167Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1094 161.875L33.0938 157.484L36.5 154.531L32 154.141L30.25 150L28.5 154.141L24 154.531L27.4062 157.484L26.3906 161.875L30.25 159.547L34.1094 161.875Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1094 96.875L3.0938 92.484L6.5 89.531L2 89.141L0.25 85L-1.5 89.141L-6 89.531L-2.5938 92.484L-3.6094 96.875L0.25 94.547L4.1094 96.875Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.906 31.9167L30.229 28.9896L32.5 27.0208L29.5 26.7604L28.333 24L27.167 26.7604L24.167 27.0208L26.437 28.9896L25.76 31.9167L28.333 30.3646L30.906 31.9167Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.609 25.875L166.594 21.484L170 18.531L165.5 18.141L163.75 14L162 18.141L157.5 18.531L160.906 21.484L159.891 25.875L163.75 23.547L167.609 25.875Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.609 172.875L166.594 168.484L170 165.531L165.5 165.141L163.75 161L162 165.141L157.5 165.531L160.906 168.484L159.891 172.875L163.75 170.547L167.609 172.875Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.7 107.016H129.114L128.811 107.74H128L129.524 104.359H130.305L131.834 107.74H131.005L130.702 107.016H130.7ZM130.452 106.422L129.911 105.128L129.37 106.422H130.454H130.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.028 105.599C137.028 106.362 136.456 106.837 135.542 106.837H134.853V107.781H134.06V104.359H135.542C136.456 104.359 137.028 104.834 137.028 105.602M136.228 105.599C136.228 105.222 135.984 105.003 135.499 105.003H134.856V106.191H135.499C135.984 106.191 136.228 105.97 136.228 105.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.109 104.359L139.624 107.74H138.841L137.358 104.359H138.218L139.262 106.775L140.319 104.359H141.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.809 107.779L143.153 106.825H142.43V107.779H141.646V104.359H143.116C144.023 104.359 144.591 104.834 144.591 105.601C144.591 106.115 144.334 106.49 143.893 106.681L144.655 107.781H143.811L143.809 107.779ZM143.071 105.005H142.43V106.197H143.071C143.552 106.197 143.794 105.973 143.794 105.601C143.794 105.228 143.552 105.005 143.071 105.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.912 104.359H147.128V107.74H147.912V104.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.116 104.359V107.74H151.467L149.765 105.687V107.74H148.983V104.359H149.638L151.335 106.412V104.359H152.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.941 106.046C152.941 105.028 153.736 104.273 154.817 104.273C155.898 104.273 156.692 105.023 156.692 106.046C156.692 107.069 155.893 107.819 154.817 107.819C153.741 107.819 152.941 107.064 152.941 106.046ZM155.89 106.046C155.89 105.394 155.429 104.948 154.817 104.948C154.204 104.948 153.743 105.394 153.743 106.046C153.743 106.698 154.204 107.144 154.817 107.144C155.429 107.144 155.89 106.698 155.89 106.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.571 107.74L158.745 106.566L157.932 107.74H157.022L158.29 106.021L157.087 104.359H157.987L158.773 105.457L159.546 104.359H160.401L159.208 105.992L160.485 107.74H159.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.432 107.111V107.74H162.794V104.359H165.37V104.988H163.579V105.722H165.16V106.331H163.579V107.111H165.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.444 107.74L167.628 106.566L166.824 107.74H165.927L167.178 106.021L165.988 104.359H166.878L167.657 105.457L168.419 104.359H169.267L168.087 105.992L169.348 107.74H168.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.894 105.599C172.894 106.362 172.322 106.837 171.407 106.837H170.719V107.781H169.926V104.359H171.407C172.322 104.359 172.894 104.834 172.894 105.602M172.091 105.599C172.091 105.222 171.847 105.003 171.363 105.003H170.716V106.191H171.363C171.847 106.191 172.091 105.97 172.091 105.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.357 107.111V107.74H173.718V104.359H176.292V104.988H174.5V105.722H176.082V106.331H174.5V107.111H176.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.425 107.779L178.771 106.825H178.048V107.779H177.264V104.359H178.734C179.642 104.359 180.209 104.834 180.209 105.601C180.209 106.115 179.952 106.49 179.511 106.681L180.273 107.781H179.429L179.425 107.779ZM178.687 105.005H178.046V106.197H178.687C179.168 106.197 179.41 105.973 179.41 105.601C179.41 105.228 179.168 105.005 178.687 105.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.881 104.359H181.098V107.74H181.881V104.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.591 107.111V107.74H182.953V104.359H185.527V104.988H183.735V105.722H185.316V106.331H183.735V107.111H185.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.59 104.359V107.74H188.94L187.238 105.687V107.74H186.457V104.359H187.112L188.809 106.412V104.359H189.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.456 106.044C190.456 105.012 191.247 104.273 192.309 104.273C192.899 104.273 193.393 104.49 193.713 104.88L193.204 105.35C192.976 105.086 192.686 104.95 192.346 104.95C191.706 104.95 191.255 105.4 191.255 106.046C191.255 106.693 191.709 107.143 192.346 107.143C192.688 107.143 192.976 107.006 193.204 106.737L193.713 107.207C193.39 107.602 192.899 107.819 192.304 107.819C191.245 107.819 190.456 107.08 190.456 106.049",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.134 107.111V107.74H194.496V104.359H197.073V104.988H195.281V105.722H196.862V106.331H195.281V107.111H197.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.262 99.6948H177.223L183.887 89.6453L177.896 80.3456H184.809L187.427 85.2859L190.916 79H198L190.747 89.6453L197.14 99.6948H190.188L187.271 94.3225L184.262 99.6948Z",
    fill: "#EEECDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.184 80.3594H128V99.6937H134.184V80.3594Z",
    fill: "#EEECDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.605 99.6937V80.3594H143.349L149.83 90.7137V80.3594H155.744V99.6937H149.869L143.53 89.5924V99.6937H137.605Z",
    fill: "#EEECDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.545 80.3594C163.206 80.3594 158.877 84.6862 158.877 90.0253C158.877 95.3644 163.206 99.6937 168.545 99.6937C173.883 99.6937 178.212 95.3644 178.212 90.0253C178.212 84.6862 173.883 80.3594 168.545 80.3594ZM168.545 93.5359C166.607 93.5359 165.035 91.9654 165.035 90.0253C165.035 88.0852 166.607 86.5172 168.545 86.5172C170.482 86.5172 172.055 88.0877 172.055 90.0253C172.055 91.963 170.482 93.5359 168.545 93.5359Z",
    fill: "#EEECDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32327_1325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 187,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalPosterInox);
export default __webpack_public_path__ + "static/media/horizontal-poster-inox.bb5f10ff235c028a14089493461c0287.svg";
export { ForwardRef as ReactComponent };